export function hidePhoneNumber(phone) {
  return phone.slice(0, 3) + '****' + phone.slice(-4)
}